<template>
  <Head :title="`Insights Dashboard - ${client.name}`" />
  
  <AppLayout>
    <div class="container-fluid">
      <div class="row justify-content-center mx-4">
        <div class="col p-0"> 
          <insights-dashboard 
            :report_pages="report_pages" 
            :client="client" 
            :prioritizations="prioritizations"
          ></insights-dashboard>
        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script setup>
import { Head } from '@inertiajs/vue3';
import AppLayout from '../../Layouts/AppLayout.vue';

defineProps({
  report_pages: Array,
  client: Object,
  prioritizations: Array,
});
</script>

